import { lazy } from "react";
import LazyLoader from "./LazyLoader";

const importModule = (path) => lazy(() => import(`../views/${path}`));

export const createRoute = (path, component) => ({
  path,
  element: <LazyLoader Component={importModule(component)} />,
});

export const createIndexRoute = (component) => ({
  index: true,
  element: <LazyLoader Component={importModule(component)} />,
});

export { importModule, LazyLoader };
